"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatLanguage = void 0;
const formatLanguage = (langOptions, langCode) => { var _a; return (_a = langOptions.find((lang) => +lang.id === langCode)) === null || _a === void 0 ? void 0 : _a.label; };
exports.formatLanguage = formatLanguage;
